import { render, staticRenderFns } from "./StaticHome.vue?vue&type=template&id=c003726c&"
import script from "./StaticHome.vue?vue&type=script&lang=js&"
export * from "./StaticHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports